import { createClient } from 'contentful';



/*
* Contentful - https://contentful.github.io/contentful.js/contentful/4.6.0/
* Contentful - https://www.contentful.com/r/knowledgebase/searching-on-references/
*/

class ContentfulHelper {

  constructor(){
     this.client = createClient({
      space: process.env.REACT_APP_CONTENTFUL_SPACE_ID,
      accessToken: process.env.REACT_APP_CONTENTFUL_ACCESS_TOKEN
    });
  }

  //Gets all published entries from a 'content_type' and optional filters
  //e.g. ContentfulHelper.fetchEntriesType('product')
  fetchEntriesType(entryType = "product", filtersValues = ""){
    return new Promise((resolve, reject) => {
      this.client.getEntries({'content_type':entryType, 'select':filtersValues, 'limit':200, 'include':9})
        .then((response) => resolve(response.items))
        .catch((error) => reject(error));
    });
  }


  //Get all entries by search reference
  fetchAllEntriesBySearchRef(contentType, fieldName, searchField){
    const searchRefObject = {};
    searchRefObject.limit = 200;
    searchRefObject.content_type = contentType;
    searchRefObject['fields.'+fieldName+'.sys.contentType.sys.id'] = fieldName;
    searchRefObject['fields.'+fieldName+'.fields.name[match]'] = searchField;

    return new Promise((resolve, reject) => {
      this.client.getEntries(searchRefObject)
      .then((response) => resolve(response.items))
      .catch((error) => reject(error));
    })
  }


  //Get product entries by day range
  fetchDurationEntriesBySearchRef(daysArr){
    const searchRefObject = {};
    searchRefObject.limit = 200;
    searchRefObject['content_type'] = "product";
    searchRefObject['fields.duration[gte]'] = daysArr[0];
    searchRefObject['fields.duration[lte]'] = daysArr[1];

    return new Promise((resolve, reject) => {
      this.client.getEntries(searchRefObject)
      .then((response) => resolve(response.items))
      .catch((error) => reject(error));
    })
  }

  //Get all entries from a space in contentful (limited to 100)
  fetchAllEntries(){
    return new Promise((resolve, reject) => {
      this.client.getEntries()
      .then((response) => resolve(response.items))
      .catch((error) => reject(error));
    });
  }

  //Get all Content types in the space from contentful
  fetchContentType(){
    return new Promise((resolve, reject) => {
      this.client.getContentTypes()
        .then((response) => resolve(response.items))
        .catch((error) => reject(error));
    });
  }
}


export default new ContentfulHelper();



// WEBPACK FOOTER //
// ./src/helpers/contentfulhelper.js